import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import Example from './Example';
import ClientProvider from './client';
export default createDemo(import.meta.url, Example, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/system/getting-started/the-sx-prop/demos/example/Example.tsx",
    "fileName": "Example.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import { Box, ThemeProvider, createTheme } from '@mui/system';\n\nconst theme = createTheme({\n  palette: {\n    background: {\n      paper: '#fff',\n    },\n    text: {\n      primary: '#173A5E',\n      secondary: '#46505A',\n    },\n    action: {\n      active: '#001E3C',\n    },\n    success: {\n      dark: '#009688',\n    },\n  },\n});\n\nexport default function Example() {\n  return (\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus-unfocused",
            "dataFrameIndent": 2,
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    <ThemeProvider theme={theme}>\n      <Box\n        sx={{\n          bgcolor: 'background.paper',\n          boxShadow: 1,\n          borderRadius: 2,\n          p: 2,\n          minWidth: 300,\n        }}\n      >\n        <Box sx={{ color: 'text.secondary' }}>Sessions</Box>\n        <Box sx={{ color: 'text.primary', fontSize: 34, fontWeight: 'medium' }}>\n          98.3 K\n        </Box>\n        <Box\n          sx={{\n            color: 'success.dark',\n            display: 'inline',\n            fontWeight: 'bold',\n            mx: 0.5,\n            fontSize: 14,\n          }}\n        >\n          +18.77%\n        </Box>\n        <Box sx={{ color: 'text.secondary', display: 'inline', fontSize: 14 }}>\n          vs. last week\n        </Box>\n      </Box>\n    </ThemeProvider>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 54,
        "focusedLines": 0,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import { Box, ThemeProvider, createTheme } from '@mui/system';\n\nconst theme = createTheme({\n  palette: {\n    background: {\n      paper: '#fff',\n    },\n    text: {\n      primary: '#173A5E',\n      secondary: '#46505A',\n    },\n    action: {\n      active: '#001E3C',\n    },\n    success: {\n      dark: '#009688',\n    },\n  },\n});\n\nexport default function Example() {\n  return (\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus-unfocused",
          "dataFrameIndent": 2
        },
        "    <ThemeProvider theme={theme}>\n      <Box\n        sx={{\n          bgcolor: 'background.paper',\n          boxShadow: 1,\n          borderRadius: 2,\n          p: 2,\n          minWidth: 300,\n        }}\n      >\n        <Box sx={{ color: 'text.secondary' }}>Sessions</Box>\n        <Box sx={{ color: 'text.primary', fontSize: 34, fontWeight: 'medium' }}>\n          98.3 K\n        </Box>\n        <Box\n          sx={{\n            color: 'success.dark',\n            display: 'inline',\n            fontWeight: 'bold',\n            mx: 0.5,\n            fontSize: 14,\n          }}\n        >\n          +18.77%\n        </Box>\n        <Box sx={{ color: 'text.secondary', display: 'inline', fontSize: 14 }}>\n          vs. last week\n        </Box>\n      </Box>\n    </ThemeProvider>\n"
      ],
      [
        "span",
        "frame",
        "  );\n}\n"
      ]
    ],
    "totalLines": 54,
    "focusedLines": 0,
    "collapsible": true,
    "externals": [
      "@mui/system"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
